/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AccessRow,
  AddBookingsRequest,
  AddInvoiceLineRequest,
  AddPackageBookingsRequest,
  ArtworkLink,
  ArtworkMatchFilesRequest,
  ArtworkMatchFilesResponse,
  ArtworkPreviewApprovalResponse,
  AttachmentFilesRequest,
  AttachmentResponse,
  AttachmentVersion,
  AuditResponse,
  BillableItemsResponse,
  BookingOperationResponse,
  BookingServiceTaskStatusItem,
  BookingsRequest,
  CampaignMonitorPicturesRequest,
  CampaignMonitorPicturesResponse,
  ChannelCommentsResponse,
  CommentAddAttachmentRequest,
  CommentMessageRequest,
  CommentReadWatermarkResponse,
  CommentRequestDataWithFiles,
  CommentResponse,
  DecorationRequest,
  DecorationServicesRequest,
  DiscreteFacetOrderFacetPageValue,
  DraftListRowResponse,
  DriveCopyRequest,
  DriveCopyResponse,
  DrivePreviewRequest,
  DriveReExpireRequest,
  DriveRefreshResponse,
  DriveShareRequest,
  DriveWeTransferImportRequest,
  ExtensionCostPreviewResponse,
  ExtensionRejectRequest,
  ExtensionRequest,
  InvoiceDetailsDefaultsResponse,
  InvoiceResponse,
  KeyVisuals,
  KeyVisualsResponse,
  LocationCommentsResponse,
  Order,
  OrderAppliedFilters,
  OrderArtworkPreviewRequest,
  OrderArtworkRequest,
  OrderBookingResponse,
  OrderCancelRequest,
  OrderCommentsBatchRequest,
  OrderCommentsRequest,
  OrderDriveSummary,
  OrderFacetResponse,
  OrderFilterResponse,
  OrderPackageBookingResponse,
  OrderRejectRequest,
  OrderRequest,
  OrderResponse,
  OrderStatusResponse,
  PackageExtensionResponse,
  PageResponseOrderResponse,
  PageResponseUserInfo,
  PendingExtensionResponse,
  PreviewGenerationAccepted,
  PreviewInvoiceRequest,
  RejectArtworkPreviewRequest,
  RejectionReasonRequest,
  SaveInvoiceRequest,
  SpaceSupportFileResponse,
  UpdateBooking,
  UpdateBookingCampaignPhotoRequest,
  UpdateBookingGeometry,
  UpdateBookingPricesRequest,
  UpdateBookingSellingPricesRequest,
  UpdateBookingsServicesRequest,
  UpdateInvoiceDraftRequest,
  UpdateMultipleBookingsAvailability,
  UpdateTaskStatusRequest,
  UploadBookingCampaignPhotoRequest,
  UploadIntent,
  UsersRequest,
  VersionApprovalDetail,
  VisualAllocationResponse,
  VisualAssignmentRequest,
  VisualResourcesRequest,
  VisualResourcesResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Orders<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags order-controller
   * @name UpdateResponsibleUsers
   * @request PUT:/orders/{orderId}/responsibleUsers
   * @secure
   * @response `200` `OrderResponse` OK
   */
  updateResponsibleUsers = (
    orderId: string,
    data: Record<string, string>,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/responsibleUsers`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags invoice-controller
   * @name SaveInvoiceProforma
   * @summary Save a complete invoice as a numbered proforma
   * @request PUT:/orders/{orderId}/invoices/{invoiceId}/proforma
   * @secure
   * @response `200` `InvoiceResponse` OK
   */
  saveInvoiceProforma = (
    orderId: string,
    invoiceId: string,
    data: SaveInvoiceRequest,
    params: RequestParams = {},
  ) =>
    this.request<InvoiceResponse, any>({
      path: `/orders/${orderId}/invoices/${invoiceId}/proforma`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags invoice-controller
   * @name SaveInvoiceDraft
   * @summary Save a draft as it stands, reporting what is still missing
   * @request PUT:/orders/{orderId}/invoices/{invoiceId}/draft
   * @secure
   * @response `200` `InvoiceResponse` OK
   */
  saveInvoiceDraft = (
    orderId: string,
    invoiceId: string,
    data: SaveInvoiceRequest,
    params: RequestParams = {},
  ) =>
    this.request<InvoiceResponse, any>({
      path: `/orders/${orderId}/invoices/${invoiceId}/draft`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name GetOrderFilters
   * @request GET:/orders/{orderId}/filters
   * @secure
   * @response `200` `OrderAppliedFilters` OK
   */
  getOrderFilters = (orderId: string, params: RequestParams = {}) =>
    this.request<OrderAppliedFilters, any>({
      path: `/orders/${orderId}/filters`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name UpdateOrderFilters
   * @request PUT:/orders/{orderId}/filters
   * @secure
   * @response `200` `OrderResponse` OK
   */
  updateOrderFilters = (
    orderId: string,
    data: OrderAppliedFilters,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/filters`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name AddOrder
   * @request POST:/orders/{planId}
   * @secure
   * @response `200` `OrderResponse` OK
   */
  addOrder = (planId: string, params: RequestParams = {}) =>
    this.request<OrderResponse, any>({
      path: `/orders/${planId}`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name RejectPackageBookings
   * @request POST:/orders/{orderId}/rejectPackageBookings
   * @secure
   * @response `200` `OrderResponse` OK
   */
  rejectPackageBookings = (
    orderId: string,
    data: BookingsRequest,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/rejectPackageBookings`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name RejectPackageBooking
   * @request POST:/orders/{orderId}/rejectPackageBooking/{packageBookingId}
   * @secure
   * @response `200` `OrderResponse` OK
   */
  rejectPackageBooking = (
    orderId: string,
    packageBookingId: string,
    data: RejectionReasonRequest,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/rejectPackageBooking/${packageBookingId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name RejectBookings
   * @request POST:/orders/{orderId}/rejectBookings
   * @secure
   * @response `200` `OrderResponse` OK
   */
  rejectBookings = (
    orderId: string,
    data: BookingsRequest,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/rejectBookings`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name RejectBooking
   * @request POST:/orders/{orderId}/rejectBooking/{bookingId}
   * @secure
   * @response `200` `OrderResponse` OK
   */
  rejectBooking = (
    orderId: string,
    bookingId: string,
    data: RejectionReasonRequest,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/rejectBooking/${bookingId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name RejectAllBookings
   * @request POST:/orders/{orderId}/rejectAllBookings
   * @secure
   * @response `200` `OrderResponse` OK
   */
  rejectAllBookings = (
    orderId: string,
    data: OrderRejectRequest,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/rejectAllBookings`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name AddPendingPackageBookings
   * @request POST:/orders/{orderId}/pendingPackageBookings
   * @secure
   * @response `200` `OrderResponse` OK
   */
  addPendingPackageBookings = (
    orderId: string,
    data: AddPackageBookingsRequest,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/pendingPackageBookings`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name AddPendingBookings
   * @request POST:/orders/{orderId}/pendingBookings
   * @secure
   * @response `200` `OrderResponse` OK
   */
  addPendingBookings = (
    orderId: string,
    data: AddBookingsRequest,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/pendingBookings`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name AddPackageBookings
   * @request POST:/orders/{orderId}/packageBookings
   * @secure
   * @response `200` `OrderResponse` OK
   */
  addPackageBookings = (
    orderId: string,
    data: AddPackageBookingsRequest,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/packageBookings`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name DeletePackageBookings
   * @request DELETE:/orders/{orderId}/packageBookings
   * @secure
   * @response `200` `OrderResponse` OK
   */
  deletePackageBookings = (
    orderId: string,
    data: BookingsRequest,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/packageBookings`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name HandleDraftPackageBookings
   * @request PATCH:/orders/{orderId}/packageBookings
   * @secure
   * @response `200` `OrderResponse` OK
   */
  handleDraftPackageBookings = (
    orderId: string,
    data: BookingsRequest,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/packageBookings`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags package-booking-extension-controller
   * @name CreateExtension
   * @request POST:/orders/{orderId}/packageBookings/{packageBookingId}/extensions
   * @secure
   * @response `200` `PackageExtensionResponse` OK
   */
  createExtension = (
    orderId: string,
    packageBookingId: string,
    data: ExtensionRequest,
    params: RequestParams = {},
  ) =>
    this.request<PackageExtensionResponse, any>({
      path: `/orders/${orderId}/packageBookings/${packageBookingId}/extensions`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags package-booking-extension-controller
   * @name UpdateExtension
   * @request PATCH:/orders/{orderId}/packageBookings/{packageBookingId}/extensions
   * @secure
   * @response `400` `PackageExtensionResponse` EXTEND_FORCE_APPROVE_CREATE_ONLY — forceApproved is a create-time decision
   */
  updateExtension = (
    orderId: string,
    packageBookingId: string,
    data: ExtensionRequest,
    params: RequestParams = {},
  ) =>
    this.request<any, PackageExtensionResponse>({
      path: `/orders/${orderId}/packageBookings/${packageBookingId}/extensions`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags package-booking-extension-controller
   * @name SubmitExtension
   * @request POST:/orders/{orderId}/packageBookings/{packageBookingId}/extensions/submit
   * @secure
   * @response `200` `PackageExtensionResponse` OK
   */
  submitExtension = (
    orderId: string,
    packageBookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<PackageExtensionResponse, any>({
      path: `/orders/${orderId}/packageBookings/${packageBookingId}/extensions/submit`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags package-booking-extension-controller
   * @name RejectExtension
   * @request POST:/orders/{orderId}/packageBookings/{packageBookingId}/extensions/reject
   * @secure
   * @response `200` `PackageExtensionResponse` OK
   */
  rejectExtension = (
    orderId: string,
    packageBookingId: string,
    data: ExtensionRejectRequest,
    params: RequestParams = {},
  ) =>
    this.request<PackageExtensionResponse, any>({
      path: `/orders/${orderId}/packageBookings/${packageBookingId}/extensions/reject`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Prices the package over the window extended to newEndDate using the same pricing that a later approve would apply. Read-only: nothing is created or saved.
   *
   * @tags package-booking-extension-controller
   * @name PreviewPackageBookingExtensionCost
   * @summary Preview the cost of extending a package booking
   * @request POST:/orders/{orderId}/packageBookings/{packageBookingId}/extensions/preview
   * @secure
   * @response `200` `ExtensionCostPreviewResponse` OK
   */
  previewPackageBookingExtensionCost = (
    orderId: string,
    packageBookingId: string,
    data: ExtensionRequest,
    params: RequestParams = {},
  ) =>
    this.request<ExtensionCostPreviewResponse, any>({
      path: `/orders/${orderId}/packageBookings/${packageBookingId}/extensions/preview`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags package-booking-extension-controller
   * @name CancelExtension
   * @request POST:/orders/{orderId}/packageBookings/{packageBookingId}/extensions/cancel
   * @secure
   * @response `200` `PackageExtensionResponse` OK
   */
  cancelExtension = (
    orderId: string,
    packageBookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<PackageExtensionResponse, any>({
      path: `/orders/${orderId}/packageBookings/${packageBookingId}/extensions/cancel`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags package-booking-extension-controller
   * @name ApproveExtension
   * @request POST:/orders/{orderId}/packageBookings/{packageBookingId}/extensions/approve
   * @secure
   * @response `200` `PackageExtensionResponse` OK
   */
  approveExtension = (
    orderId: string,
    packageBookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<PackageExtensionResponse, any>({
      path: `/orders/${orderId}/packageBookings/${packageBookingId}/extensions/approve`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name UploadOrderPackageBookingArtwork
   * @summary Upload Order Artwork
   * @request POST:/orders/{orderId}/packageBookings/{bookingId}/artwork
   * @secure
   * @response `200` `OrderResponse` OK
   */
  uploadOrderPackageBookingArtwork = (
    orderId: string,
    bookingId: string,
    data: OrderArtworkRequest,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/packageBookings/${bookingId}/artwork`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags invoice-controller
   * @name CreateInvoiceDraft
   * @summary Start a new draft invoice
   * @request POST:/orders/{orderId}/invoices/drafts
   * @secure
   * @response `200` `InvoiceResponse` OK
   */
  createInvoiceDraft = (orderId: string, params: RequestParams = {}) =>
    this.request<InvoiceResponse, any>({
      path: `/orders/${orderId}/invoices/drafts`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags invoice-controller
   * @name PreviewInvoice
   * @summary Live document preview from unsaved details
   * @request POST:/orders/{orderId}/invoices/drafts/{draftId}/preview
   * @secure
   * @response `200` `string` OK
   */
  previewInvoice = (
    orderId: string,
    draftId: string,
    data: PreviewInvoiceRequest,
    params: RequestParams = {},
  ) =>
    this.request<string, any>({
      path: `/orders/${orderId}/invoices/drafts/${draftId}/preview`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags invoice-controller
   * @name AddInvoiceLine
   * @summary Add Product: reserve the checked items as one line
   * @request POST:/orders/{orderId}/invoices/drafts/{draftId}/lines
   * @secure
   * @response `200` `InvoiceResponse` OK
   */
  addInvoiceLine = (
    orderId: string,
    draftId: string,
    data: AddInvoiceLineRequest,
    params: RequestParams = {},
  ) =>
    this.request<InvoiceResponse, any>({
      path: `/orders/${orderId}/invoices/drafts/${draftId}/lines`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags drive-controller
   * @name ImportWeTransfer
   * @request POST:/orders/{orderId}/drive/folders/{kind}/wetransfer-import
   * @secure
   * @response `200` `void` OK
   */
  importWeTransfer = (
    orderId: string,
    kind: string,
    data: DriveWeTransferImportRequest,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/orders/${orderId}/drive/folders/${kind}/wetransfer-import`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags drive-controller
   * @name ImportWeTransfer1
   * @request POST:/orders/{orderId}/drive/folders/{kind}/{folderId}/wetransfer-import
   * @secure
   * @response `200` `void` OK
   */
  importWeTransfer1 = (
    orderId: string,
    kind: string,
    folderId: string,
    data: DriveWeTransferImportRequest,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/orders/${orderId}/drive/folders/${kind}/${folderId}/wetransfer-import`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags drive-controller
   * @name UploadIntent
   * @request POST:/orders/{orderId}/drive/folders/{kind}/{folderId}/upload-intent
   * @secure
   * @response `200` `UploadIntent` OK
   */
  uploadIntent = (
    orderId: string,
    kind: string,
    folderId: string,
    params: RequestParams = {},
  ) =>
    this.request<UploadIntent, any>({
      path: `/orders/${orderId}/drive/folders/${kind}/${folderId}/upload-intent`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags drive-controller
   * @name UploadIntent1
   * @request POST:/orders/{orderId}/drive/folders/{kind}/upload-intent
   * @secure
   * @response `200` `UploadIntent` OK
   */
  uploadIntent1 = (orderId: string, kind: string, params: RequestParams = {}) =>
    this.request<UploadIntent, any>({
      path: `/orders/${orderId}/drive/folders/${kind}/upload-intent`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags drive-controller
   * @name Refresh
   * @request POST:/orders/{orderId}/drive/folders/{kind}/refresh
   * @secure
   * @response `200` `DriveRefreshResponse` OK
   */
  refresh = (orderId: string, kind: string, params: RequestParams = {}) =>
    this.request<DriveRefreshResponse, any>({
      path: `/orders/${orderId}/drive/folders/${kind}/refresh`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags drive-controller
   * @name Refresh1
   * @request POST:/orders/{orderId}/drive/folders/{kind}/{folderId}/refresh
   * @secure
   * @response `200` `DriveRefreshResponse` OK
   */
  refresh1 = (
    orderId: string,
    kind: string,
    folderId: string,
    params: RequestParams = {},
  ) =>
    this.request<DriveRefreshResponse, any>({
      path: `/orders/${orderId}/drive/folders/${kind}/${folderId}/refresh`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags drive-controller
   * @name Access
   * @request GET:/orders/{orderId}/drive/folders/{kind}/access
   * @secure
   * @response `200` `(AccessRow)[]` OK
   */
  access = (orderId: string, kind: string, params: RequestParams = {}) =>
    this.request<AccessRow[], any>({
      path: `/orders/${orderId}/drive/folders/${kind}/access`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags drive-controller
   * @name Share
   * @request POST:/orders/{orderId}/drive/folders/{kind}/access
   * @secure
   * @response `200` `AccessRow` OK
   */
  share = (
    orderId: string,
    kind: string,
    data: DriveShareRequest,
    params: RequestParams = {},
  ) =>
    this.request<AccessRow, any>({
      path: `/orders/${orderId}/drive/folders/${kind}/access`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags drive-controller
   * @name Access1
   * @request GET:/orders/{orderId}/drive/folders/{kind}/{folderId}/access
   * @secure
   * @response `200` `(AccessRow)[]` OK
   */
  access1 = (
    orderId: string,
    kind: string,
    folderId: string,
    params: RequestParams = {},
  ) =>
    this.request<AccessRow[], any>({
      path: `/orders/${orderId}/drive/folders/${kind}/${folderId}/access`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags drive-controller
   * @name Share1
   * @request POST:/orders/{orderId}/drive/folders/{kind}/{folderId}/access
   * @secure
   * @response `200` `AccessRow` OK
   */
  share1 = (
    orderId: string,
    kind: string,
    folderId: string,
    data: DriveShareRequest,
    params: RequestParams = {},
  ) =>
    this.request<AccessRow, any>({
      path: `/orders/${orderId}/drive/folders/${kind}/${folderId}/access`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags drive-controller
   * @name GeneratePreviews
   * @request POST:/orders/{orderId}/drive/folders/decoration/{operationId}/previews
   * @secure
   * @response `200` `PreviewGenerationAccepted` OK
   */
  generatePreviews = (
    orderId: string,
    operationId: string,
    data: DrivePreviewRequest,
    params: RequestParams = {},
  ) =>
    this.request<PreviewGenerationAccepted, any>({
      path: `/orders/${orderId}/drive/folders/decoration/${operationId}/previews`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags drive-controller
   * @name Copy
   * @request POST:/orders/{orderId}/drive/copy
   * @secure
   * @response `200` `DriveCopyResponse` OK
   */
  copy = (
    orderId: string,
    data: DriveCopyRequest,
    params: RequestParams = {},
  ) =>
    this.request<DriveCopyResponse, any>({
      path: `/orders/${orderId}/drive/copy`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name DownloadOrderDocuments
   * @summary Download Order Documents
   * @request GET:/orders/{orderId}/documents
   * @secure
   * @response `200` `StreamingResponseBody` OK
   */
  downloadOrderDocuments = (orderId: string, params: RequestParams = {}) =>
    this.request<Blob, any>({
      path: `/orders/${orderId}/documents`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name UpdateOrderDocuments
   * @request POST:/orders/{orderId}/documents
   * @secure
   * @response `200` `OrderResponse` OK
   */
  updateOrderDocuments = (
    orderId: string,
    data: KeyVisuals,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/documents`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name ConfirmOrderByPost
   * @request POST:/orders/{orderId}/confirm
   * @secure
   * @response `200` `OrderResponse` OK
   */
  confirmOrderByPost = (orderId: string, params: RequestParams = {}) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/confirm`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name AddBookings
   * @request POST:/orders/{orderId}/bookings
   * @secure
   * @response `200` `OrderResponse` OK
   */
  addBookings = (
    orderId: string,
    data: AddBookingsRequest,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/bookings`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name DeleteBookings
   * @request DELETE:/orders/{orderId}/bookings
   * @secure
   * @response `200` `OrderResponse` OK
   */
  deleteBookings = (
    orderId: string,
    data: BookingsRequest,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/bookings`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name HandleDraftBookings
   * @request PATCH:/orders/{orderId}/bookings
   * @secure
   * @response `200` `OrderResponse` OK
   */
  handleDraftBookings = (
    orderId: string,
    data: BookingsRequest,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/bookings`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags booking-operation-controller
   * @name GetAssignedVisuals
   * @request GET:/orders/{orderId}/bookings/{bookingId}/operations/{operationId}/visuals
   * @secure
   * @response `200` `(VisualAllocationResponse)[]` OK
   */
  getAssignedVisuals = (
    orderId: string,
    bookingId: string,
    operationId: string,
    params: RequestParams = {},
  ) =>
    this.request<VisualAllocationResponse[], any>({
      path: `/orders/${orderId}/bookings/${bookingId}/operations/${operationId}/visuals`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags booking-operation-controller
   * @name AssignVisual
   * @request POST:/orders/{orderId}/bookings/{bookingId}/operations/{operationId}/visuals
   * @secure
   * @response `200` `(VisualAllocationResponse)[]` OK
   */
  assignVisual = (
    orderId: string,
    bookingId: string,
    operationId: string,
    data: VisualAssignmentRequest,
    params: RequestParams = {},
  ) =>
    this.request<VisualAllocationResponse[], any>({
      path: `/orders/${orderId}/bookings/${bookingId}/operations/${operationId}/visuals`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags booking-operation-controller
   * @name UnassignVisual
   * @request DELETE:/orders/{orderId}/bookings/{bookingId}/operations/{operationId}/visuals
   * @secure
   * @response `200` `(VisualAllocationResponse)[]` OK
   */
  unassignVisual = (
    orderId: string,
    bookingId: string,
    operationId: string,
    query: {
      kind:
        | "ARTWORK"
        | "ARTWORK_PREVIEW"
        | "ARTWORK_LINK"
        | "ARTWORK_MATCH_FILE";
      reference: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<VisualAllocationResponse[], any>({
      path: `/orders/${orderId}/bookings/${bookingId}/operations/${operationId}/visuals`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags booking-operation-controller
   * @name CreateExtension1
   * @request POST:/orders/{orderId}/bookings/{bookingId}/extensions
   * @secure
   * @response `200` `BookingOperationResponse` OK
   */
  createExtension1 = (
    orderId: string,
    bookingId: string,
    data: ExtensionRequest,
    params: RequestParams = {},
  ) =>
    this.request<BookingOperationResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/extensions`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags booking-operation-controller
   * @name SubmitExtension1
   * @request POST:/orders/{orderId}/bookings/{bookingId}/extensions/{operationId}/submit
   * @secure
   * @response `200` `BookingOperationResponse` OK
   */
  submitExtension1 = (
    orderId: string,
    bookingId: string,
    operationId: string,
    params: RequestParams = {},
  ) =>
    this.request<BookingOperationResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/extensions/${operationId}/submit`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags booking-operation-controller
   * @name RejectExtension1
   * @request POST:/orders/{orderId}/bookings/{bookingId}/extensions/{operationId}/reject
   * @secure
   * @response `200` `BookingOperationResponse` OK
   */
  rejectExtension1 = (
    orderId: string,
    bookingId: string,
    operationId: string,
    data: ExtensionRejectRequest,
    params: RequestParams = {},
  ) =>
    this.request<BookingOperationResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/extensions/${operationId}/reject`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags booking-operation-controller
   * @name CancelExtension1
   * @request POST:/orders/{orderId}/bookings/{bookingId}/extensions/{operationId}/cancel
   * @secure
   * @response `200` `BookingOperationResponse` OK
   */
  cancelExtension1 = (
    orderId: string,
    bookingId: string,
    operationId: string,
    params: RequestParams = {},
  ) =>
    this.request<BookingOperationResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/extensions/${operationId}/cancel`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags booking-operation-controller
   * @name ApproveExtension1
   * @request POST:/orders/{orderId}/bookings/{bookingId}/extensions/{operationId}/approve
   * @secure
   * @response `200` `BookingOperationResponse` OK
   */
  approveExtension1 = (
    orderId: string,
    bookingId: string,
    operationId: string,
    params: RequestParams = {},
  ) =>
    this.request<BookingOperationResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/extensions/${operationId}/approve`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * @description Prices the booking over the window extended to newEndDate using the same pricing that a later submit would freeze. Read-only: nothing is created or saved.
   *
   * @tags booking-operation-controller
   * @name PreviewBookingExtensionCost
   * @summary Preview the cost of extending a booking
   * @request POST:/orders/{orderId}/bookings/{bookingId}/extensions/preview
   * @secure
   * @response `200` `ExtensionCostPreviewResponse` OK
   */
  previewBookingExtensionCost = (
    orderId: string,
    bookingId: string,
    data: ExtensionRequest,
    params: RequestParams = {},
  ) =>
    this.request<ExtensionCostPreviewResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/extensions/preview`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags booking-operation-controller
   * @name AddDecoration
   * @request POST:/orders/{orderId}/bookings/{bookingId}/decorations
   * @secure
   * @response `200` `BookingOperationResponse` OK
   */
  addDecoration = (
    orderId: string,
    bookingId: string,
    data: DecorationRequest,
    params: RequestParams = {},
  ) =>
    this.request<BookingOperationResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/decorations`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags booking-operation-controller
   * @name CancelDecoration
   * @request POST:/orders/{orderId}/bookings/{bookingId}/decorations/{operationId}/cancel
   * @secure
   * @response `200` `BookingOperationResponse` OK
   */
  cancelDecoration = (
    orderId: string,
    bookingId: string,
    operationId: string,
    params: RequestParams = {},
  ) =>
    this.request<BookingOperationResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/decorations/${operationId}/cancel`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name UploadCampaignPhotos
   * @request POST:/orders/{orderId}/bookings/{bookingId}/campaignPhotos
   * @secure
   * @response `200` `OrderResponse` OK
   */
  uploadCampaignPhotos = (
    orderId: string,
    bookingId: string,
    data: UploadBookingCampaignPhotoRequest,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/campaignPhotos`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name GetBookingCampaignMonitorFiles
   * @summary Get Booking Campaign Monitor Files
   * @request GET:/orders/{orderId}/bookings/{bookingId}/campaignMonitor
   * @secure
   * @response `200` `CampaignMonitorPicturesResponse` OK
   */
  getBookingCampaignMonitorFiles = (
    orderId: string,
    bookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<CampaignMonitorPicturesResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/campaignMonitor`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name UploadBookingCampaignMonitorFiles
   * @summary Upload Booking Campaign Monitor Files
   * @request POST:/orders/{orderId}/bookings/{bookingId}/campaignMonitor
   * @secure
   * @response `200` `CampaignMonitorPicturesResponse` OK
   */
  uploadBookingCampaignMonitorFiles = (
    orderId: string,
    bookingId: string,
    data: CampaignMonitorPicturesRequest,
    query?: {
      operationId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<CampaignMonitorPicturesResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/campaignMonitor`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name DownloadOrderArtworkDocuments
   * @summary Download Order Artwork Documents
   * @request GET:/orders/{orderId}/bookings/{bookingId}/artwork
   * @secure
   * @response `200` `StreamingResponseBody` OK
   */
  downloadOrderArtworkDocuments = (
    orderId: string,
    bookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/artwork`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name UploadOrderArtwork
   * @summary Upload Order Artwork
   * @request POST:/orders/{orderId}/bookings/{bookingId}/artwork
   * @secure
   * @response `200` `OrderResponse` OK
   */
  uploadOrderArtwork = (
    orderId: string,
    bookingId: string,
    data: OrderArtworkRequest,
    query?: {
      operationId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/artwork`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name UpdateBookingArtWorkLink
   * @request PATCH:/orders/{orderId}/bookings/{bookingId}/artwork
   * @secure
   * @response `200` `OrderResponse` OK
   */
  updateBookingArtWorkLink = (
    orderId: string,
    bookingId: string,
    data: ArtworkLink[],
    query?: {
      operationId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/artwork`,
      method: "PATCH",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name DownloadOrderArtworkPreview
   * @summary Download Artwork Previews for Order Booking
   * @request GET:/orders/{orderId}/bookings/{bookingId}/artworkPreview
   * @secure
   * @response `200` `StreamingResponseBody` OK
   */
  downloadOrderArtworkPreview = (
    orderId: string,
    bookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/artworkPreview`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name UploadOrderArtworkPreview
   * @summary Upload Artwork Preview to Order Booking
   * @request POST:/orders/{orderId}/bookings/{bookingId}/artworkPreview
   * @secure
   * @response `200` `OrderResponse` OK
   */
  uploadOrderArtworkPreview = (
    orderId: string,
    bookingId: string,
    data: OrderArtworkPreviewRequest,
    query?: {
      operationId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/artworkPreview`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name UpdateArtworkPreviewVersion
   * @summary Update Artwork Preview Version
   * @request POST:/orders/{orderId}/bookings/{bookingId}/artworkPreview/{attachmentId}
   * @secure
   * @response `200` `AttachmentResponse` OK
   */
  updateArtworkPreviewVersion = (
    orderId: string,
    bookingId: string,
    attachmentId: string,
    data: AttachmentFilesRequest,
    params: RequestParams = {},
  ) =>
    this.request<AttachmentResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/artworkPreview/${attachmentId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags artwork-preview-approval-controller
   * @name GetArtworkPreviewComments
   * @request GET:/orders/{orderId}/bookings/{bookingId}/artworkPreview/{attachmentId}/comments
   * @secure
   * @response `200` `Record<string,(CommentResponse)[]>` OK
   */
  getArtworkPreviewComments = (
    orderId: string,
    bookingId: string,
    attachmentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Record<string, CommentResponse[]>, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/artworkPreview/${attachmentId}/comments`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags artwork-preview-approval-controller
   * @name AddArtworkPreviewComment
   * @request POST:/orders/{orderId}/bookings/{bookingId}/artworkPreview/{attachmentId}/comments
   * @secure
   * @response `200` `CommentResponse` OK
   */
  addArtworkPreviewComment = (
    orderId: string,
    bookingId: string,
    attachmentId: string,
    data: CommentRequestDataWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/artworkPreview/${attachmentId}/comments`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags artwork-preview-approval-controller
   * @name ApproveArtworkPreview
   * @request POST:/orders/{orderId}/bookings/{bookingId}/artworkPreview/{attachmentId}/approvals
   * @secure
   * @response `200` `VersionApprovalDetail` OK
   */
  approveArtworkPreview = (
    orderId: string,
    bookingId: string,
    attachmentId: string,
    params: RequestParams = {},
  ) =>
    this.request<VersionApprovalDetail, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/artworkPreview/${attachmentId}/approvals`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags artwork-preview-approval-controller
   * @name RejectArtworkPreview
   * @request DELETE:/orders/{orderId}/bookings/{bookingId}/artworkPreview/{attachmentId}/approvals
   * @secure
   * @response `200` `VersionApprovalDetail` OK
   */
  rejectArtworkPreview = (
    orderId: string,
    bookingId: string,
    attachmentId: string,
    data: RejectArtworkPreviewRequest,
    params: RequestParams = {},
  ) =>
    this.request<VersionApprovalDetail, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/artworkPreview/${attachmentId}/approvals`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name GetBookingArtworkMatchFiles
   * @summary Get Booking Artwork Match Files
   * @request GET:/orders/{orderId}/bookings/{bookingId}/artworkMatch
   * @secure
   * @response `200` `ArtworkMatchFilesResponse` OK
   */
  getBookingArtworkMatchFiles = (
    orderId: string,
    bookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<ArtworkMatchFilesResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/artworkMatch`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name UploadBookingArtworkMatchFiles
   * @summary Upload Booking Artwork Match Files
   * @request POST:/orders/{orderId}/bookings/{bookingId}/artworkMatch
   * @secure
   * @response `200` `ArtworkMatchFilesResponse` OK
   */
  uploadBookingArtworkMatchFiles = (
    orderId: string,
    bookingId: string,
    data: ArtworkMatchFilesRequest,
    params: RequestParams = {},
  ) =>
    this.request<ArtworkMatchFilesResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/artworkMatch`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name ApprovePackageBookings
   * @request POST:/orders/{orderId}/approvePackageBookings
   * @secure
   * @response `200` `OrderResponse` OK
   */
  approvePackageBookings = (
    orderId: string,
    data: BookingsRequest,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/approvePackageBookings`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name ApprovePackageBooking
   * @request POST:/orders/{orderId}/approvePackageBooking/{packageBookingId}
   * @secure
   * @response `200` `OrderResponse` OK
   */
  approvePackageBooking = (
    orderId: string,
    packageBookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/approvePackageBooking/${packageBookingId}`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name ApproveBookings
   * @request POST:/orders/{orderId}/approveBookings
   * @secure
   * @response `200` `OrderResponse` OK
   */
  approveBookings = (
    orderId: string,
    data: BookingsRequest,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/approveBookings`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name ApproveBooking
   * @request POST:/orders/{orderId}/approveBooking/{bookingId}
   * @secure
   * @response `200` `OrderResponse` OK
   */
  approveBooking = (
    orderId: string,
    bookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/approveBooking/${bookingId}`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name ApproveAllBookings
   * @request POST:/orders/{orderId}/approveAllBookings
   * @secure
   * @response `200` `OrderResponse` OK
   */
  approveAllBookings = (orderId: string, params: RequestParams = {}) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/approveAllBookings`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name ListOrders
   * @request POST:/orders/getOrders
   * @secure
   * @response `200` `PageResponseOrderResponse` OK
   */
  listOrders = (data: OrderRequest, params: RequestParams = {}) =>
    this.request<PageResponseOrderResponse, any>({
      path: `/orders/getOrders`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name GetOrdersSpaceSupportFile
   * @request POST:/orders/getOrdersSpaceSupportFile
   * @secure
   * @response `200` `SpaceSupportFileResponse` OK
   */
  getOrdersSpaceSupportFile = (params: RequestParams = {}) =>
    this.request<SpaceSupportFileResponse, any>({
      path: `/orders/getOrdersSpaceSupportFile`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name GetOrderFacets
   * @summary Get Order Facets
   * @request POST:/orders/getOrders/filters
   * @secure
   * @response `200` `OrderFacetResponse` OK
   */
  getOrderFacets = (data: OrderRequest, params: RequestParams = {}) =>
    this.request<OrderFacetResponse, any>({
      path: `/orders/getOrders/filters`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name GetOrderFacetPage
   * @summary Get One Order Facet Page
   * @request POST:/orders/getOrders/filters/{facetGroup}
   * @secure
   * @response `200` `DiscreteFacetOrderFacetPageValue` OK
   */
  getOrderFacetPage = (
    facetGroup:
      | "STATUS"
      | "DATES"
      | "BUDGET"
      | "CLIENT"
      | "ADVERTISER_ORGANIZATIONS"
      | "AGENCY_COMPANIES"
      | "DAILY_TRAFFIC"
      | "TOTAL_COST"
      | "LOCATIONS"
      | "CITIES"
      | "LOCATION_COMPANIES"
      | "BRANDS",
    data: OrderRequest,
    query?: {
      /**
       * @format int32
       * @min 0
       * @max 10000
       * @default 0
       */
      offset?: number;
      /**
       * @format int32
       * @min 1
       * @max 200
       * @default 50
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<DiscreteFacetOrderFacetPageValue, any>({
      path: `/orders/getOrders/filters/${facetGroup}`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name GetOrderCommentsBatch
   * @summary Get comments for an order across several channels in one call
   * @request POST:/orders/getCommentsBatch/{orderId}
   * @secure
   * @response `200` `(ChannelCommentsResponse)[]` OK
   */
  getOrderCommentsBatch = (
    orderId: string,
    data: OrderCommentsBatchRequest,
    params: RequestParams = {},
  ) =>
    this.request<ChannelCommentsResponse[], any>({
      path: `/orders/getCommentsBatch/${orderId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name GetOrderComments
   * @summary Get comments for an order
   * @request POST:/orders/getComments/{orderId}
   * @secure
   * @response `200` `(LocationCommentsResponse)[]` OK
   */
  getOrderComments = (
    orderId: string,
    data: OrderCommentsRequest,
    params: RequestParams = {},
  ) =>
    this.request<LocationCommentsResponse[], any>({
      path: `/orders/getComments/${orderId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name AddOrderComment
   * @summary Add comment to an order
   * @request POST:/orders/comments/{orderId}
   * @secure
   * @response `200` `CommentResponse` OK
   */
  addOrderComment = (
    orderId: string,
    data: CommentRequestDataWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/orders/comments/${orderId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name GetOrderUsersForComments
   * @request POST:/orders/comments/{orderId}/users/{locationId}
   * @secure
   * @response `200` `PageResponseUserInfo` OK
   */
  getOrderUsersForComments = (
    orderId: string,
    locationId: string,
    data: UsersRequest,
    params: RequestParams = {},
  ) =>
    this.request<PageResponseUserInfo, any>({
      path: `/orders/comments/${orderId}/users/${locationId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name DeleteOrderCommentAttachment
   * @summary Delete Order Comment Attachment
   * @request POST:/orders/comments/deleteAttachments/{commentId}
   * @secure
   * @response `200` `CommentResponse` OK
   */
  deleteOrderCommentAttachment = (
    commentId: string,
    data: CommentAddAttachmentRequest,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/orders/comments/deleteAttachments/${commentId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name AddOrderCommentAttachment
   * @summary Add Order Comment Attachment
   * @request POST:/orders/comments/addAttachments/{commentId}
   * @secure
   * @response `200` `CommentResponse` OK
   */
  addOrderCommentAttachment = (
    commentId: string,
    data: CommentAddAttachmentRequest,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/orders/comments/addAttachments/${commentId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name GetOrderBookingsForSpace
   * @summary Get Order Bookings for Space
   * @request GET:/orders/bookings/{spaceId}
   * @deprecated
   * @secure
   * @response `200` `(OrderBookingResponse)[]` OK
   */
  getOrderBookingsForSpace = (spaceId: string, params: RequestParams = {}) =>
    this.request<OrderBookingResponse[], any>({
      path: `/orders/bookings/${spaceId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name LocationAddOrderBookings
   * @request POST:/orders/bookings/{spaceId}
   * @secure
   * @response `200` `OrderBookingResponse` OK
   */
  locationAddOrderBookings = (
    spaceId: string,
    data: Order,
    params: RequestParams = {},
  ) =>
    this.request<OrderBookingResponse, any>({
      path: `/orders/bookings/${spaceId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name UpdateNewVersion1
   * @request POST:/orders/attachmentsVersions/{resourceId}/{category}/{attachmentId}
   * @secure
   * @response `200` `AttachmentResponse` OK
   */
  updateNewVersion1 = (
    resourceId: string,
    category: string,
    attachmentId: string,
    query: {
      filesRequest: AttachmentFilesRequest;
    },
    params: RequestParams = {},
  ) =>
    this.request<AttachmentResponse, any>({
      path: `/orders/attachmentsVersions/${resourceId}/${category}/${attachmentId}`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name GetOrderVisualResources
   * @request GET:/orders/{orderId}/visualResources
   * @secure
   * @response `200` `VisualResourcesResponse` OK
   */
  getOrderVisualResources = (orderId: string, params: RequestParams = {}) =>
    this.request<VisualResourcesResponse, any>({
      path: `/orders/${orderId}/visualResources`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name PatchOrderVisualResources
   * @request PATCH:/orders/{orderId}/visualResources
   * @secure
   * @response `200` `VisualResourcesResponse` OK
   */
  patchOrderVisualResources = (
    orderId: string,
    data: VisualResourcesRequest,
    params: RequestParams = {},
  ) =>
    this.request<VisualResourcesResponse, any>({
      path: `/orders/${orderId}/visualResources`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name UpdatePackageBooking
   * @request PATCH:/orders/{orderId}/packageBookings/{bookingId}
   * @secure
   * @response `200` `OrderResponse` OK
   */
  updatePackageBooking = (
    orderId: string,
    bookingId: string,
    data: UpdateBooking,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/packageBookings/${bookingId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name UpdateStatusForOrderKeyVisuals
   * @request PATCH:/orders/{orderId}/keyVisuals/{taskId}
   * @secure
   * @response `200` `KeyVisualsResponse` OK
   */
  updateStatusForOrderKeyVisuals = (
    orderId: string,
    taskId: string,
    data: UpdateTaskStatusRequest,
    params: RequestParams = {},
  ) =>
    this.request<KeyVisualsResponse, any>({
      path: `/orders/${orderId}/keyVisuals/${taskId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags invoice-controller
   * @name UpdateInvoiceDraft
   * @summary Optional columns and per-line name, PO and cells
   * @request PATCH:/orders/{orderId}/invoices/drafts/{draftId}
   * @secure
   * @response `200` `InvoiceResponse` OK
   */
  updateInvoiceDraft = (
    orderId: string,
    draftId: string,
    data: UpdateInvoiceDraftRequest,
    params: RequestParams = {},
  ) =>
    this.request<InvoiceResponse, any>({
      path: `/orders/${orderId}/invoices/drafts/${draftId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags drive-controller
   * @name Unshare
   * @request DELETE:/orders/{orderId}/drive/folders/{kind}/{folderId}/access/{permissionId}
   * @secure
   * @response `200` `void` OK
   */
  unshare = (
    orderId: string,
    kind: string,
    folderId: string,
    permissionId: string,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/orders/${orderId}/drive/folders/${kind}/${folderId}/access/${permissionId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags drive-controller
   * @name ReExpire
   * @request PATCH:/orders/{orderId}/drive/folders/{kind}/{folderId}/access/{permissionId}
   * @secure
   * @response `200` `void` OK
   */
  reExpire = (
    orderId: string,
    kind: string,
    folderId: string,
    permissionId: string,
    data: DriveReExpireRequest,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/orders/${orderId}/drive/folders/${kind}/${folderId}/access/${permissionId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags drive-controller
   * @name Unshare1
   * @request DELETE:/orders/{orderId}/drive/folders/{kind}/access/{permissionId}
   * @secure
   * @response `200` `void` OK
   */
  unshare1 = (
    orderId: string,
    kind: string,
    permissionId: string,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/orders/${orderId}/drive/folders/${kind}/access/${permissionId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags drive-controller
   * @name ReExpire1
   * @request PATCH:/orders/{orderId}/drive/folders/{kind}/access/{permissionId}
   * @secure
   * @response `200` `void` OK
   */
  reExpire1 = (
    orderId: string,
    kind: string,
    permissionId: string,
    data: DriveReExpireRequest,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/orders/${orderId}/drive/folders/${kind}/access/${permissionId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name UpdateBooking
   * @request PATCH:/orders/{orderId}/bookings/{bookingId}
   * @secure
   * @response `200` `OrderResponse` OK
   */
  updateBooking = (
    orderId: string,
    bookingId: string,
    data: UpdateBooking,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name GetBookingGeometry
   * @request GET:/orders/{orderId}/bookings/{bookingId}/geometry
   * @secure
   * @response `200` `string` OK
   */
  getBookingGeometry = (
    orderId: string,
    bookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<string, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/geometry`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name UpdateBookingGeometry
   * @request PATCH:/orders/{orderId}/bookings/{bookingId}/geometry
   * @secure
   * @response `200` `string` OK
   */
  updateBookingGeometry = (
    orderId: string,
    bookingId: string,
    data: UpdateBookingGeometry,
    params: RequestParams = {},
  ) =>
    this.request<string, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/geometry`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags booking-operation-controller
   * @name UpdateExtension1
   * @request PATCH:/orders/{orderId}/bookings/{bookingId}/extensions/{operationId}
   * @secure
   * @response `400` `BookingOperationResponse` EXTEND_FORCE_APPROVE_CREATE_ONLY — forceApproved is a create-time decision
   */
  updateExtension1 = (
    orderId: string,
    bookingId: string,
    operationId: string,
    data: ExtensionRequest,
    params: RequestParams = {},
  ) =>
    this.request<any, BookingOperationResponse>({
      path: `/orders/${orderId}/bookings/${bookingId}/extensions/${operationId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags booking-operation-controller
   * @name UpdateDecorationServices
   * @request PATCH:/orders/{orderId}/bookings/{bookingId}/decorations/{operationId}
   * @secure
   * @response `200` `BookingOperationResponse` OK
   */
  updateDecorationServices = (
    orderId: string,
    bookingId: string,
    operationId: string,
    data: DecorationServicesRequest,
    params: RequestParams = {},
  ) =>
    this.request<BookingOperationResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/decorations/${operationId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name DownloadOrderCampaignPhoto
   * @summary Download Order Campaign Photo
   * @request GET:/orders/{orderId}/bookings/{bookingId}/campaignPhotos/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadOrderCampaignPhoto = (
    orderId: string,
    bookingId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<File, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/campaignPhotos/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name DeleteCampaignPhoto
   * @request DELETE:/orders/{orderId}/bookings/{bookingId}/campaignPhotos/{documentId}
   * @secure
   * @response `200` `OrderResponse` OK
   */
  deleteCampaignPhoto = (
    orderId: string,
    bookingId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/campaignPhotos/${documentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name UpdateCampaignPhotosStatus
   * @request PATCH:/orders/{orderId}/bookings/{bookingId}/campaignPhotos/{documentId}
   * @secure
   * @response `200` `OrderResponse` OK
   */
  updateCampaignPhotosStatus = (
    orderId: string,
    bookingId: string,
    documentId: string,
    data: UpdateBookingCampaignPhotoRequest,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/campaignPhotos/${documentId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags artwork-preview-approval-controller
   * @name MarkArtworkPreviewRead
   * @request PATCH:/orders/{orderId}/bookings/{bookingId}/artworkPreview/{attachmentId}/read
   * @secure
   * @response `200` `CommentReadWatermarkResponse` OK
   */
  markArtworkPreviewRead = (
    orderId: string,
    bookingId: string,
    attachmentId: string,
    params: RequestParams = {},
  ) =>
    this.request<CommentReadWatermarkResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/artworkPreview/${attachmentId}/read`,
      method: "PATCH",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name UpdateBookingsServices
   * @request PATCH:/orders/{orderId}/bookings/services
   * @secure
   * @response `200` `OrderResponse` OK
   */
  updateBookingsServices = (
    orderId: string,
    data: UpdateBookingsServicesRequest,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/bookings/services`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Update the SELLING prices of one or more bookings of an order. Every bookingUpdate carries EXACTLY ONE of four kinds: monthlyPrice (selling rate per month, priced as monthly x period of the addressed lane), discounts (add / remove selling discount percentages on the addressed lane), sellingTotal (the booking's selling total; when several bookings carry a sellingTotal the sum is redistributed by their current selling share) or commercialAddition (the booking-level commercial addition override, 100..1000 %, which reprices every lane without a monthly override). operationId addresses the lane: omitted or the CREATE operation id = the contract lane; an APPROVED EXTEND id = that extension's lane (absolute for sellingTotal). commercialAddition is booking-level and refuses an operationId. packageBookingUpdates carries the same four kinds for PACKAGE bookings, addressed by packageBookingId and with NO operationId: a package is sold as a unit off its own rate card and an extension widens its window rather than adding a lane beside it, so it has exactly one selling lane. A sellingTotal on a package row joins the same redistribution pool as the booking rows. At least one of the two lists must be non-empty. Callers: the advertiser side of the order — an advertiser-module user on its own orders, a location only on its INTERNAL orders, backoffice; services never. A mandatory reason (5..500 characters) lands in the selling trail and in the audit fact.
   *
   * @tags order-price-controller
   * @name UpdateBookingSellingPrices
   * @summary Update Booking Selling Prices
   * @request PATCH:/orders/{orderId}/bookings/selling-prices
   * @secure
   * @response `200` `OrderResponse` OK
   */
  updateBookingSellingPrices = (
    orderId: string,
    data: UpdateBookingSellingPricesRequest,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/bookings/selling-prices`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Preview the SELLING prices of one or more bookings of an order without persisting anything. Every bookingUpdate carries EXACTLY ONE of four kinds: monthlyPrice, discounts, sellingTotal (redistributed by current selling share when several rows carry one) or commercialAddition (booking-level, 100..1000 %). operationId addresses the lane: omitted or the CREATE operation id = the contract lane; an APPROVED EXTEND id = that extension's lane. commercialAddition refuses an operationId. packageBookingUpdates previews the same four kinds on PACKAGE bookings, addressed by packageBookingId and carrying no operationId — a package has exactly one selling lane. Callers: the advertiser side of the order — an advertiser-module user on its own orders, a location only on its INTERNAL orders, backoffice; services never. The reason (5..500 characters) is mandatory.
   *
   * @tags order-price-controller
   * @name PreviewBookingSellingPrices
   * @summary Preview Booking Selling Prices
   * @request PATCH:/orders/{orderId}/bookings/selling-prices/preview
   * @secure
   * @response `200` `OrderResponse` OK
   */
  previewBookingSellingPrices = (
    orderId: string,
    data: UpdateBookingSellingPricesRequest,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/bookings/selling-prices/preview`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Update prices for one or multiple bookings when the advertiser and location belong to the same organization. Supports updating monthly price, discounts, or total price. All changes require a reason for audit purposes. A bookingUpdate may carry an optional operationId to target one of the booking's operations: an APPROVED EXTEND accepts all three kinds scoped to the extension (campaignCost = the extension's new price; discounts / monthlyPrice reprice the extension over its own window), and the booking's CREATE operation id is accepted as the legacy whole-contract lane (same as omitting operationId). ADR 0002 "Extension pricing model".
   *
   * @tags order-price-controller
   * @name UpdateInternalBookingPrices
   * @summary Update Internal Booking Prices
   * @request PATCH:/orders/{orderId}/bookings/prices
   * @secure
   * @response `200` `OrderResponse` OK
   */
  updateInternalBookingPrices = (
    orderId: string,
    data: UpdateBookingPricesRequest,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/bookings/prices`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Preview Update prices for one or multiple bookings when the advertiser and location belong to the same organization. Supports updating monthly price, discounts, or total price. All changes require a reason for audit purposes. A bookingUpdate may carry an optional operationId to target one of the booking's operations: an APPROVED EXTEND accepts all three kinds scoped to the extension (campaignCost = the extension's new price; discounts / monthlyPrice reprice the extension over its own window), and the booking's CREATE operation id is accepted as the legacy whole-contract lane (same as omitting operationId). ADR 0002 "Extension pricing model".
   *
   * @tags order-price-controller
   * @name PreviewInternalBookingPrices
   * @summary Get Internal Booking Prices Preview
   * @request PATCH:/orders/{orderId}/bookings/prices/preview
   * @secure
   * @response `200` `OrderResponse` OK
   */
  previewInternalBookingPrices = (
    orderId: string,
    data: UpdateBookingPricesRequest,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/bookings/prices/preview`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name UpdateOrderBookingsAvailability
   * @request PATCH:/orders/{orderId}/bookings/availability
   * @secure
   * @response `200` `OrderResponse` OK
   */
  updateOrderBookingsAvailability = (
    orderId: string,
    data: UpdateMultipleBookingsAvailability,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/bookings/availability`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name DeleteOrderComment
   * @summary Delete a comment from an order
   * @request DELETE:/orders/comments/{commentId}
   * @secure
   * @response `200` `void` OK
   */
  deleteOrderComment = (commentId: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/orders/comments/${commentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name UpdateOrderComment
   * @summary Update Order Comment
   * @request PATCH:/orders/comments/{commentId}
   * @secure
   * @response `200` `CommentResponse` OK
   */
  updateOrderComment = (
    commentId: string,
    data: CommentMessageRequest,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/orders/comments/${commentId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name SetActiveVersion1
   * @request PATCH:/orders/attachmentsVersions/{resourceId}/{attachmentId}/{version}
   * @secure
   * @response `200` `AttachmentResponse` OK
   */
  setActiveVersion1 = (
    resourceId: string,
    attachmentId: string,
    version: number,
    params: RequestParams = {},
  ) =>
    this.request<AttachmentResponse, any>({
      path: `/orders/attachmentsVersions/${resourceId}/${attachmentId}/${version}`,
      method: "PATCH",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name GetOrderById
   * @summary Get Order by ID
   * @request GET:/orders/{orderId}
   * @secure
   * @response `200` `OrderResponse` OK
   */
  getOrderById = (orderId: string, params: RequestParams = {}) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name CancelOrder
   * @request DELETE:/orders/{orderId}
   * @secure
   * @response `200` `OrderResponse` OK
   */
  cancelOrder = (
    orderId: string,
    data: OrderCancelRequest,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name GetOrderServiceTasksStatus
   * @summary Get Service Tasks Status for Order
   * @request GET:/orders/{orderId}/service-tasks-status
   * @secure
   * @response `200` `Record<string,(BookingServiceTaskStatusItem)[]>` OK
   */
  getOrderServiceTasksStatus = (orderId: string, params: RequestParams = {}) =>
    this.request<Record<string, BookingServiceTaskStatusItem[]>, any>({
      path: `/orders/${orderId}/service-tasks-status`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-status-controller
   * @name GetOrderStatus
   * @request GET:/orders/{orderId}/orderStatus
   * @secure
   * @response `200` `OrderStatusResponse` OK
   */
  getOrderStatus = (orderId: string, params: RequestParams = {}) =>
    this.request<OrderStatusResponse, any>({
      path: `/orders/${orderId}/orderStatus`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name DownloadOrderLayoutFiles
   * @request GET:/orders/{orderId}/layoutFiles
   * @secure
   * @response `200` `StreamingResponseBody` OK
   */
  downloadOrderLayoutFiles = (orderId: string, params: RequestParams = {}) =>
    this.request<Blob, any>({
      path: `/orders/${orderId}/layoutFiles`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name DownloadOrderLayoutFilesDocument
   * @request GET:/orders/{orderId}/layoutFiles/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadOrderLayoutFilesDocument = (
    orderId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/orders/${orderId}/layoutFiles/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name GetOrderKeyVisuals
   * @request GET:/orders/{orderId}/keyVisuals
   * @secure
   * @response `200` `KeyVisualsResponse` OK
   */
  getOrderKeyVisuals = (orderId: string, params: RequestParams = {}) =>
    this.request<KeyVisualsResponse, any>({
      path: `/orders/${orderId}/keyVisuals`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags invoice-controller
   * @name GetOrderInvoices
   * @summary The order's draft invoices
   * @request GET:/orders/{orderId}/invoices
   * @secure
   * @response `200` `(DraftListRowResponse)[]` OK
   */
  getOrderInvoices = (orderId: string, params: RequestParams = {}) =>
    this.request<DraftListRowResponse[], any>({
      path: `/orders/${orderId}/invoices`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags invoice-controller
   * @name GetInvoice
   * @summary One invoice with its lines
   * @request GET:/orders/{orderId}/invoices/{invoiceId}
   * @secure
   * @response `200` `InvoiceResponse` OK
   */
  getInvoice = (
    orderId: string,
    invoiceId: string,
    params: RequestParams = {},
  ) =>
    this.request<InvoiceResponse, any>({
      path: `/orders/${orderId}/invoices/${invoiceId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags invoice-controller
   * @name DeleteInvoice
   * @summary Delete an invoice and release its items
   * @request DELETE:/orders/{orderId}/invoices/{invoiceId}
   * @secure
   * @response `200` `void` OK
   */
  deleteInvoice = (
    orderId: string,
    invoiceId: string,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/orders/${orderId}/invoices/${invoiceId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags invoice-controller
   * @name DownloadInvoiceDocument
   * @summary Render the invoice as a PDF
   * @request GET:/orders/{orderId}/invoices/{invoiceId}/document
   * @secure
   * @response `200` `Blob` OK
   */
  downloadInvoiceDocument = (
    orderId: string,
    invoiceId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/orders/${orderId}/invoices/${invoiceId}/document`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags invoice-controller
   * @name GetInvoiceDetailsDefaults
   * @summary Prefills for the Invoice Details form
   * @request GET:/orders/{orderId}/invoices/details-defaults
   * @secure
   * @response `200` `InvoiceDetailsDefaultsResponse` OK
   */
  getInvoiceDetailsDefaults = (
    orderId: string,
    query?: {
      invoiceId?: string;
      currency?: "EUR" | "RON";
      /** @format date */
      issueDate?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<InvoiceDetailsDefaultsResponse, any>({
      path: `/orders/${orderId}/invoices/details-defaults`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags invoice-controller
   * @name GetBillableItems
   * @summary What of the order is still billable
   * @request GET:/orders/{orderId}/invoices/billable-items
   * @secure
   * @response `200` `BillableItemsResponse` OK
   */
  getBillableItems = (orderId: string, params: RequestParams = {}) =>
    this.request<BillableItemsResponse, any>({
      path: `/orders/${orderId}/invoices/billable-items`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name GetLayoutSketchToImage
   * @request GET:/orders/{orderId}/imageLayoutSketch/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  getLayoutSketchToImage = (
    orderId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<File, any>({
      path: `/orders/${orderId}/imageLayoutSketch/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-extensions-controller
   * @name GetPendingExtensions
   * @summary Pending extension requests of an order
   * @request GET:/orders/{orderId}/extensions/pending
   * @secure
   * @response `200` `(PendingExtensionResponse)[]` OK
   */
  getPendingExtensions = (orderId: string, params: RequestParams = {}) =>
    this.request<PendingExtensionResponse[], any>({
      path: `/orders/${orderId}/extensions/pending`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags drive-controller
   * @name Summary
   * @request GET:/orders/{orderId}/drive
   * @secure
   * @response `200` `OrderDriveSummary` OK
   */
  summary = (orderId: string, params: RequestParams = {}) =>
    this.request<OrderDriveSummary, any>({
      path: `/orders/${orderId}/drive`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name DownloadOrderDocument
   * @summary Download Order Document
   * @request GET:/orders/{orderId}/documents/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadOrderDocument = (
    orderId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/orders/${orderId}/documents/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name DeleteOrderDocument
   * @summary Delete Order Document
   * @request DELETE:/orders/{orderId}/documents/{documentId}
   * @secure
   * @response `200` `OrderResponse` OK
   */
  deleteOrderDocument = (
    orderId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/documents/${documentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags booking-operation-controller
   * @name GetTimeline
   * @request GET:/orders/{orderId}/bookings/{bookingId}/operations
   * @secure
   * @response `200` `(BookingOperationResponse)[]` OK
   */
  getTimeline = (
    orderId: string,
    bookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<BookingOperationResponse[], any>({
      path: `/orders/${orderId}/bookings/${bookingId}/operations`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name DownloadBookingCampaignMonitorFile
   * @summary Download Booking Campaign Monitor File
   * @request GET:/orders/{orderId}/bookings/{bookingId}/campaignMonitor/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadBookingCampaignMonitorFile = (
    orderId: string,
    bookingId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<File, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/campaignMonitor/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name DeleteBookingCampaignMonitorFile
   * @summary Delete Booking Campaign Monitor File
   * @request DELETE:/orders/{orderId}/bookings/{bookingId}/campaignMonitor/{documentId}
   * @secure
   * @response `200` `CampaignMonitorPicturesResponse` OK
   */
  deleteBookingCampaignMonitorFile = (
    orderId: string,
    bookingId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<CampaignMonitorPicturesResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/campaignMonitor/${documentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name GetBookingCampaignMonitorThumbnail
   * @summary Get Booking Campaign Monitor File Thumbnail
   * @request GET:/orders/{orderId}/bookings/{bookingId}/campaignMonitor/{documentId}/thumbnail
   * @secure
   * @response `200` `File` OK
   */
  getBookingCampaignMonitorThumbnail = (
    orderId: string,
    bookingId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/campaignMonitor/${documentId}/thumbnail`,
      method: "GET",
      secure: true,
      format: "blob",
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name DownloadOrderArtworkPreviewDocument
   * @summary Download Single Artwork Preview Document
   * @request GET:/orders/{orderId}/bookings/{bookingId}/artworkPreview/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadOrderArtworkPreviewDocument = (
    orderId: string,
    bookingId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/artworkPreview/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name DeleteOrderArtworkPreview
   * @summary Delete Order Artwork Preview
   * @request DELETE:/orders/{orderId}/bookings/{bookingId}/artworkPreview/{documentId}
   * @secure
   * @response `200` `OrderResponse` OK
   */
  deleteOrderArtworkPreview = (
    orderId: string,
    bookingId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/artworkPreview/${documentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags artwork-preview-approval-controller
   * @name GetArtworkPreviewApprovals
   * @request GET:/orders/{orderId}/bookings/{bookingId}/artworkPreview/approvals
   * @secure
   * @response `200` `ArtworkPreviewApprovalResponse` OK
   */
  getArtworkPreviewApprovals = (
    orderId: string,
    bookingId: string,
    params: RequestParams = {},
  ) =>
    this.request<ArtworkPreviewApprovalResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/artworkPreview/approvals`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name DownloadArtworkMatchFile1
   * @request GET:/orders/{orderId}/bookings/{bookingId}/artworkMatch/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadArtworkMatchFile1 = (
    orderId: string,
    bookingId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<File, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/artworkMatch/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name DeleteBookingArtworkMatchFile
   * @summary Delete Booking Artwork Match File
   * @request DELETE:/orders/{orderId}/bookings/{bookingId}/artworkMatch/{documentId}
   * @secure
   * @response `200` `ArtworkMatchFilesResponse` OK
   */
  deleteBookingArtworkMatchFile = (
    orderId: string,
    bookingId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<ArtworkMatchFilesResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/artworkMatch/${documentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name GetBookingArtworkMatchThumbnail
   * @summary Get Booking Artwork Match File Thumbnail
   * @request GET:/orders/{orderId}/bookings/{bookingId}/artworkMatch/{documentId}/thumbnail
   * @secure
   * @response `200` `File` OK
   */
  getBookingArtworkMatchThumbnail = (
    orderId: string,
    bookingId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/artworkMatch/${documentId}/thumbnail`,
      method: "GET",
      secure: true,
      format: "blob",
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name DownloadOrderArtworkDocument
   * @summary Download Order Artwork Document
   * @request GET:/orders/{orderId}/bookings/{bookingId}/artwork/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadOrderArtworkDocument = (
    orderId: string,
    bookingId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/artwork/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags artwork-preview-approval-controller
   * @name GetOrderArtworkPreviewApprovals
   * @request GET:/orders/{orderId}/artworkPreview/approvals
   * @secure
   * @response `200` `(ArtworkPreviewApprovalResponse)[]` OK
   */
  getOrderArtworkPreviewApprovals = (
    orderId: string,
    params: RequestParams = {},
  ) =>
    this.request<ArtworkPreviewApprovalResponse[], any>({
      path: `/orders/${orderId}/artworkPreview/approvals`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name GetOrderPackageBookingsForPackage
   * @summary Get Order Bookings for Advertising Package
   * @request GET:/orders/packageBookings/{advertisingPackageId}
   * @deprecated
   * @secure
   * @response `200` `(OrderPackageBookingResponse)[]` OK
   */
  getOrderPackageBookingsForPackage = (
    advertisingPackageId: string,
    params: RequestParams = {},
  ) =>
    this.request<OrderPackageBookingResponse[], any>({
      path: `/orders/packageBookings/${advertisingPackageId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name GetOrderHistory
   * @summary Get Order History
   * @request GET:/orders/history/{resourceId}
   * @secure
   * @response `200` `(AuditResponse)[]` OK
   */
  getOrderHistory = (resourceId: string, params: RequestParams = {}) =>
    this.request<AuditResponse[], any>({
      path: `/orders/history/${resourceId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name GetOrderFilterValues
   * @summary Get Order Filter Values
   * @request GET:/orders/filters
   * @deprecated
   * @secure
   * @response `200` `OrderFilterResponse` OK
   */
  getOrderFilterValues = (params: RequestParams = {}) =>
    this.request<OrderFilterResponse, any>({
      path: `/orders/filters`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name ConfirmOrder
   * @request GET:/orders/confirm/{orderId}
   * @deprecated
   * @secure
   * @response `200` `OrderResponse` OK
   */
  confirmOrder = (orderId: string, params: RequestParams = {}) =>
    this.request<OrderResponse, any>({
      path: `/orders/confirm/${orderId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name DownloadOrderCommentDocument
   * @summary Download Order Comment Document
   * @request GET:/orders/comments/{resourceId}/documents/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadOrderCommentDocument = (
    resourceId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<File, any>({
      path: `/orders/comments/${resourceId}/documents/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name GetAttachmentsWithVersions2
   * @request GET:/orders/attachmentsVersions/{resourceId}
   * @secure
   * @response `200` `(AttachmentResponse)[]` OK
   */
  getAttachmentsWithVersions2 = (
    resourceId: string,
    params: RequestParams = {},
  ) =>
    this.request<AttachmentResponse[], any>({
      path: `/orders/attachmentsVersions/${resourceId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name GetAttachmentWithVersions2
   * @request GET:/orders/attachmentsVersions/{resourceId}/{attachmentId}
   * @secure
   * @response `200` `(AttachmentVersion)[]` OK
   */
  getAttachmentWithVersions2 = (
    resourceId: string,
    attachmentId: string,
    params: RequestParams = {},
  ) =>
    this.request<AttachmentVersion[], any>({
      path: `/orders/attachmentsVersions/${resourceId}/${attachmentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name DownloadAttachmentVersion2
   * @request GET:/orders/attachmentsVersions/{resourceId}/{attachmentId}/{versionId}
   * @secure
   * @response `200` `File` OK
   */
  downloadAttachmentVersion2 = (
    resourceId: string,
    attachmentId: string,
    versionId: number,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/orders/attachmentsVersions/${resourceId}/${attachmentId}/${versionId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name DeleteVersion1
   * @request DELETE:/orders/attachmentsVersions/{resourceId}/{attachmentId}/{versionId}
   * @secure
   * @response `200` `AttachmentResponse` OK
   */
  deleteVersion1 = (
    resourceId: string,
    attachmentId: string,
    versionId: number,
    params: RequestParams = {},
  ) =>
    this.request<AttachmentResponse, any>({
      path: `/orders/attachmentsVersions/${resourceId}/${attachmentId}/${versionId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags invoice-controller
   * @name DeleteInvoiceLine
   * @summary Delete a line, releasing exactly its items
   * @request DELETE:/orders/{orderId}/invoices/drafts/{draftId}/lines/{lineId}
   * @secure
   * @response `200` `InvoiceResponse` OK
   */
  deleteInvoiceLine = (
    orderId: string,
    draftId: string,
    lineId: string,
    params: RequestParams = {},
  ) =>
    this.request<InvoiceResponse, any>({
      path: `/orders/${orderId}/invoices/drafts/${draftId}/lines/${lineId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-controller
   * @name DeleteOrderArtwork
   * @summary Delete Order Artwork
   * @request DELETE:/orders/{orderId}/bookings/{bookingId}/artwork/{attachmentId}
   * @secure
   * @response `200` `OrderResponse` OK
   */
  deleteOrderArtwork = (
    orderId: string,
    bookingId: string,
    attachmentId: string,
    params: RequestParams = {},
  ) =>
    this.request<OrderResponse, any>({
      path: `/orders/${orderId}/bookings/${bookingId}/artwork/${attachmentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
}
